import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CargoOperationViewModel } from 'src/types/ViewModel/Stowage/CargoOperation/CargoOperationViewModel';
import OdfjellInputComponent from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import { Product } from 'src/types/ViewModel/Stowage/Product/Product';
import { SelectOption } from 'src/types/ViewModel/SelectOption';
import TradeNameWrapper from '../TradeNameWrapper';
import {
    DefaultFlexStrechedWrapper,
    DefaultPanelWrapper,
    PanelSectionContent,
    PanelSubHeader,
} from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import { getIbcShipTypeString, getMarpolPollutionCategoryString } from 'src/utils/stowage/cargoOptionUtils';
import { getTradeName, getCharterName } from '../utils/cargoOperationDisplayUtils';

interface CommoditySectionProps {
    cargoOperationVM: CargoOperationViewModel;
    isFieldReadOnly: (field: string) => boolean;
    onTradeNameChange: (e: SelectOption, product: Product) => void;
}

export const CommoditySection: React.FC<CommoditySectionProps> = ({ cargoOperationVM, isFieldReadOnly, onTradeNameChange }) => {
    return (
        <PanelSectionContent>
            <PanelSubHeader>
                Commodity
                {(cargoOperationVM.cargo.productChanges?.id ?? cargoOperationVM.cargo.productId) && (
                    <span className="ext-info">
                        <a
                            href={
                                'https://commoditybook.odfjell.com/#/product/' +
                                (cargoOperationVM.cargo.productChanges?.id ?? cargoOperationVM.cargo.productId)
                            }
                            target="_blank"
                            title="Click here to open the Commodity Book"
                            rel="noreferrer"
                        >
                            <FontAwesomeIcon className="external-link-icon" icon="external-link-alt" />
                        </a>
                    </span>
                )}
            </PanelSubHeader>

            <DefaultFlexStrechedWrapper alignTop noMargin className="highlight-panel">
                <DefaultPanelWrapper flexWidth="48%" noMargin>
                    {!isFieldReadOnly('productName') && (
                        <TradeNameWrapper tradeName={getTradeName(cargoOperationVM)} onTradeNameChange={onTradeNameChange} />
                    )}
                    {isFieldReadOnly('productName') && (
                        <OdfjellInputComponent
                            isReadOnly={true}
                            type={'text'}
                            description={'Trade name'}
                            value={getTradeName(cargoOperationVM)}
                            name={'tradeName'}
                            dataObject={cargoOperationVM}
                            leaveBlank={true}
                            disableUnit={true}
                            textAlign="left"
                            labelMinWidth={140}
                        />
                    )}
                    <OdfjellInputComponent
                        isReadOnly={true}
                        type={'text'}
                        description={'Product name'}
                        value={cargoOperationVM.cargo.productChanges?.category?.name ?? cargoOperationVM.cargo.product?.category?.name}
                        name={'productName'}
                        dataObject={cargoOperationVM}
                        leaveBlank={true}
                        disableUnit={true}
                        textAlign="left"
                        labelMinWidth={140}
                    />
                </DefaultPanelWrapper>

                <DefaultPanelWrapper flexWidth="48%" noMargin>
                    <OdfjellInputComponent
                        isReadOnly={true}
                        type={'text'}
                        description={'Charterer'}
                        value={getCharterName(cargoOperationVM)}
                        name={'chartererName'}
                        dataObject={cargoOperationVM}
                        leaveBlank={true}
                        disableUnit={true}
                        textAlign="left"
                        labelMinWidth={140}
                    />
                    <OdfjellInputComponent
                        isReadOnly={true}
                        type={'number'}
                        description={'USCG number'}
                        value={cargoOperationVM.cargo.product?.uscgGroup?.number ?? null}
                        name={'uscgNumber'}
                        dataObject={cargoOperationVM}
                        leaveBlank={true}
                        disableUnit={true}
                        textAlign="left"
                        labelMinWidth={140}
                    />
                    <OdfjellInputComponent
                        isReadOnly={true}
                        type={'number'}
                        description={'Pollution category'}
                        value={getMarpolPollutionCategoryString(cargoOperationVM.cargo.product?.category.marpolPollutionCategory)}
                        name={'marpolPollutionCategory'}
                        dataObject={cargoOperationVM}
                        leaveBlank={true}
                        disableUnit={true}
                        textAlign="left"
                        labelMinWidth={140}
                    />
                    <OdfjellInputComponent
                        isReadOnly={true}
                        type={'number'}
                        description={'Ship type'}
                        value={getIbcShipTypeString(cargoOperationVM.cargo.product?.category?.shipType)}
                        name={'shipType'}
                        dataObject={cargoOperationVM}
                        leaveBlank={true}
                        disableUnit={true}
                        textAlign="left"
                        labelMinWidth={140}
                    />
                </DefaultPanelWrapper>
            </DefaultFlexStrechedWrapper>
        </PanelSectionContent>
    );
};
